import { useEffect, useState, useRef } from "react";
import { openDB } from "idb";
import { useDataContext } from "./contexts/DataProvider";

const API_URL = "https://sab.expresswebs.ca/slim/videos";

const VideoPlayer = () => {
  const [videos, setVideos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [downloadCount, setDownloadCount] = useState(0);
  const [totalVideos, setTotalVideos] = useState(0);
  const [ready, setReady] = useState(false);
  const videoRef = useRef();
  const { dashboard } = useDataContext();
   
    
    const currentSetting = dashboard.length > 0 ? dashboard[0].setting_name : null;

  useEffect(() => {
    const loadVideos = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();

        if (!data.videos || data.videos.length === 0) {
          console.error("❌ No videos found in API response");
          return;
        }

        const videoUrls = data.videos.map((video) => video.url);
        setTotalVideos(videoUrls.length);

        const db = await openDB("videoCache", 1, {
          upgrade(db) {
            if (!db.objectStoreNames.contains("videos")) {
              db.createObjectStore("videos");
            }
          },
        });

        const cachedVideos = [];

        for (let i = 0; i < videoUrls.length; i++) {
          const url = videoUrls[i];
          const cachedBlob = await db.get("videos", url);

          if (cachedBlob) {
            cachedVideos.push(URL.createObjectURL(cachedBlob));
          } else {
            const response = await fetch(url);
            const blob = await response.blob();
            await db.put("videos", blob, url);
            cachedVideos.push(URL.createObjectURL(blob));
          }

          setDownloadCount((prev) =>
            prev + 1 > videoUrls.length ? videoUrls.length : prev + 1
          );
        }

        // Small delay to ensure blob URLs are stable
        await new Promise((res) => setTimeout(res, 200));
        setVideos(cachedVideos);
        setReady(true);
      } catch (error) {
        console.error("❌ Error fetching videos:", error);
      }
    };

    loadVideos();

    return () => {
      videos.forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (video && ready) {
      video.load();
      video.play().catch((err) => {
        console.warn("Autoplay failed. Retrying...", err);
        setTimeout(() => video.play(), 5000);
      });
    }
  }, [videos, currentIndex, ready]);

  const handleVideoEnd = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  const overallProgress =
    totalVideos > 0
      ? Math.min(Math.round((downloadCount / totalVideos) * 100), 100)
      : 0;

  return (
    <div>
      {!ready ? (
        <div>
          <p>Downloading videos... ({downloadCount} of {totalVideos})</p>
          <div
            style={{
              background: "#eee",
              borderRadius: 4,
              height: 10,
              width: "100%",
              overflow: "hidden",
              marginTop: 5,
              marginBottom: 10,
            }}
          >
            <div
              style={{
                width: `${overallProgress}%`,
                background: "#1890ff",
                height: "100%",
                transition: "width 0.2s ease",
              }}
            />
          </div>
          <p>{overallProgress}% complete</p>
        </div>
      ) : videos.length > 0 ? (
        <video
          key={`video-${currentIndex}`}
          ref={videoRef}
          autoPlay
          playsInline // ✅ Required for mobile autoplay
          loop={false}
          width="100%"
          height="auto"
          preload="auto"
          onEnded={handleVideoEnd}
        >
          <source src={videos[currentIndex]} type="video/mp4" />
        </video>
      ) : (
        <p>No videos available.</p>
      )}
    </div>
  );
};

export default VideoPlayer;
